// extracted by mini-css-extract-plugin
export default {"preferencesCompleted":"PreferencesCompleted__preferencesCompleted-CEUF","fadeIn":"PreferencesCompleted__fadeIn-g59z"};